<template>
  <div class="container">
    <div class="p-4">
      Socket IO connection:
      {{ $socket.connected ? 'Connected' : 'Disconnected' }}
    </div>
    <div class="row">
      <div class="col-4">
        Inbox
      </div>
      <div class="col-8">
        <div class="message-area">
          <div v-for="(data, index) in messages" :key="index">
            <customer-chat
              :message="data.message"
              v-if="data.sender_type === 'customer'"
            ></customer-chat>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col">
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="3"
                  v-model="message"
                ></textarea>
              </div>
            </div>
            <button class="btn btn-primary mt-4" @click="postMessage()">
              Send Message
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CustomerChat from '@/components/coversation/CustomerChat'

export default {
  data () {
    return {
      messages: [],
      message: null,
      responseData: null,
      options: { quality: { default: '720p' } }
    }
  },
  components: {
    CustomerChat
  },
  sockets: {
    connect () {
      // console.log('socket connected')
    },
    newMessage (val) {
      this.messages.push(val)
      console.log(
        'this method was fired by the socket server. eg: io.emit("customEmit", data)'
      )
    }
  },
  methods: {
    async loadMessages () {
      const res = await axios.get('/messages')
      if (!res.data.error) {
        this.messages = res.data.messages
      }
    },
    async postMessage () {
      const url = '/push-message'
      const submitData = {
        userId: 'Uc7271c353980ddfefcc59eeda48dda0f',
        message: this.message
      }
      await axios.post(url, submitData)
      // this.$socket.client is `socket.io-client` instance
      // this.$socket.client.emit('chatMessage', this.message)
    }
  },
  mounted () {
    this.loadMessages()
  }
}
</script>

<style scoped>
.message-area {
  height: 80vh;
  overflow-y: auto;
}
</style>
